module.exports = __webpack_public_path__ + "img/tropi4.2d480d62.jpg";